module.exports = __webpack_public_path__ + "static/media/zhangxu.afe0b5b3.png";